const kitThumbs = [...document.querySelectorAll('.kit-product .pdp-thumb')];
const kitMainPhoto = document.querySelector('#kit-main-photo');
const kitGalleryCaptionTitle = document.querySelector('#kit-gallery-caption-title');
const kitGalleryCaptionText = document.querySelector('#kit-gallery-caption-text');
const kitGalleryCounter = document.querySelector('#kit-gallery-counter');
const kitGalleryPanels = [...document.querySelectorAll('.kit-gallery-panel')];
let kitPhotoIndex = 0;
let kitPhotoRequest = 0;
const kitGalleryLanguage = document.documentElement.lang.slice(0, 2);
const kitGalleryCopy = {
  fr: {heroLabel: 'Photo 1 — Produit sur fond nude', heroAlt: color => 'Applicateur ' + color + ' et une recharge solide de déodorant sur fond nude'},
  de: {heroLabel: 'Foto 1 — Produkt auf Nude-Hintergrund', heroAlt: color => 'Applikator ' + color + ' und eine feste Deodorant-Nachfüllung auf Nude-Hintergrund'},
  en: {heroLabel: 'Photo 1 — Product on a nude background', heroAlt: color => color + ' applicator and one solid deodorant refill on a nude background'}
}[kitGalleryLanguage] || {
  heroLabel: 'Photo 1 — Produit sur fond nude', heroAlt: color => 'Applicateur ' + color + ' et une recharge solide de déodorant sur fond nude'
};

async function showKitPhoto(index, force = false) {
  const nextIndex = (index + kitThumbs.length) % kitThumbs.length;
  if (nextIndex === kitPhotoIndex && !force) return;
  const next = kitThumbs[nextIndex];
  const src = next.dataset.src;
  const alt = next.dataset.alt;
  const request = ++kitPhotoRequest;
  kitPhotoIndex = nextIndex;
  // Keep the current photo visible until the requested image is decoded.
  const preview = new Image();
  const loaded = await new Promise(resolve => {
    preview.onload = () => resolve(true);
    preview.onerror = () => resolve(false);
    (window.BasicProductImages ? window.BasicProductImages.setImage(preview, src, kitMainPhoto) : (preview.removeAttribute('srcset'), preview.src = src));
    if (preview.complete && preview.naturalWidth > 0) resolve(true);
  });
  if (loaded && typeof preview.decode === 'function') {
    try { await preview.decode(); } catch { /* A decoded candidate change must not block the selected color. */ }
  }
  if (request !== kitPhotoRequest) return;
  if (loaded && window.BasicProductImages) window.BasicProductImages.setImage(kitMainPhoto, src);
  else {
    // Retry the exact selected master when its responsive preload fails.
    kitMainPhoto.removeAttribute('srcset');
    kitMainPhoto.src = src;
  }
  kitMainPhoto.alt = alt;
  const kind = next.dataset.kind;
  kitMainPhoto.hidden = Boolean(kind);
  kitGalleryPanels.forEach(panel => {
    panel.hidden = panel.id !== 'kit-gallery-' + kind;
  });
  kitGalleryCaptionTitle.textContent = next.dataset.captionTitle;
  kitGalleryCaptionText.textContent = next.dataset.captionText;
  kitGalleryCounter.textContent = String(nextIndex + 1).padStart(2, '0') + ' / ' + String(kitThumbs.length).padStart(2, '0');
  kitThumbs.forEach((thumb, i) => {
    const selected = i === nextIndex;
    thumb.classList.toggle('is-active', selected);
    thumb.setAttribute('aria-pressed', String(selected));
  });
  const strip = next.parentElement;
  if (next.offsetLeft < strip.scrollLeft) strip.scrollLeft = next.offsetLeft;
  else if (next.offsetLeft + next.offsetWidth > strip.scrollLeft + strip.clientWidth) {
    strip.scrollLeft = next.offsetLeft + next.offsetWidth - strip.clientWidth;
  }
}

kitThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showKitPhoto(index)));
document.querySelector('#kit-photo-prev').addEventListener('click', () => showKitPhoto(kitPhotoIndex - 1));
document.querySelector('#kit-photo-next').addEventListener('click', () => showKitPhoto(kitPhotoIndex + 1));
let kitTouchX = null;
document.querySelector('#kit-main-image').addEventListener('touchstart', event => {
  kitTouchX = event.changedTouches[0].screenX;
}, {passive:true});
document.querySelector('#kit-main-image').addEventListener('touchend', event => {
  if (kitTouchX === null) return;
  const difference = event.changedTouches[0].screenX - kitTouchX;
  if (Math.abs(difference) > 45) showKitPhoto(kitPhotoIndex + (difference < 0 ? 1 : -1));
  kitTouchX = null;
}, {passive:true});

const kitUgcDialog = document.querySelector('#kit-ugc-dialog');
const kitUgcFeed = document.querySelector('#kit-ugc-feed');
const kitUgcSlides = [...kitUgcFeed.querySelectorAll('.kit-ugc-slide')];
const kitUgcBefore = kitUgcSlides[1].cloneNode(true);
const kitUgcAfter = kitUgcSlides[0].cloneNode(true);
kitUgcBefore.setAttribute('aria-hidden', 'true');
kitUgcAfter.setAttribute('aria-hidden', 'true');
kitUgcBefore.querySelector('video').preload = 'none';
kitUgcAfter.querySelector('video').preload = 'none';
kitUgcFeed.prepend(kitUgcBefore);
kitUgcFeed.append(kitUgcAfter);
const kitUgcVideos = [...kitUgcFeed.querySelectorAll('video')];
const kitUgcOpen = document.querySelector('#kit-ugc-open');
let kitUgcActive = -1;
let kitUgcScrollFrame = 0;
let kitUgcWrapTimer = 0;
let kitUgcResetting = false;

function activateKitUgc(index, resumeTime = null, muted = false) {
  if (!kitUgcDialog.open || index === kitUgcActive || index < 0 || index >= kitUgcVideos.length) return;
  kitUgcActive = index;
  kitUgcVideos.forEach((video, videoIndex) => {
    if (videoIndex === index) return;
    video.pause();
    if (video.readyState) video.currentTime = 0;
  });
  const video = kitUgcVideos[index];
  if (resumeTime !== null && video.readyState) video.currentTime = resumeTime;
  video.muted = muted;
  video.play().catch(() => {
    if (!kitUgcDialog.open || kitUgcActive !== index) return;
    video.muted = true;
    video.play().catch(() => {});
  });
}

function wrapKitUgc() {
  if (!kitUgcDialog.open || kitUgcResetting) return;
  const height = kitUgcFeed.clientHeight;
  const index = Math.round(kitUgcFeed.scrollTop / height);
  if (Math.abs(kitUgcFeed.scrollTop - index * height) > 2) return;
  const target = index === 0 ? 2 : index === 3 ? 1 : null;
  if (target === null) return;
  const time = kitUgcVideos[index].currentTime;
  const muted = kitUgcVideos[index].muted;
  kitUgcResetting = true;
  kitUgcFeed.style.scrollSnapType = 'none';
  kitUgcFeed.scrollTop = target * height;
  activateKitUgc(target, time, muted);
  requestAnimationFrame(() => {
    kitUgcFeed.style.scrollSnapType = '';
    kitUgcResetting = false;
  });
}

kitUgcOpen.addEventListener('click', () => {
  kitUgcDialog.showModal();
  document.body.classList.add('kit-ugc-open');
  kitUgcResetting = true;
  kitUgcFeed.style.scrollSnapType = 'none';
  kitUgcFeed.scrollTop = kitUgcFeed.clientHeight;
  kitUgcActive = -1;
  activateKitUgc(1);
  requestAnimationFrame(() => {
    kitUgcFeed.style.scrollSnapType = '';
    kitUgcResetting = false;
  });
  document.querySelector('#kit-ugc-close').focus();
});
kitUgcFeed.addEventListener('scroll', () => {
  if (kitUgcResetting) return;
  cancelAnimationFrame(kitUgcScrollFrame);
  kitUgcScrollFrame = requestAnimationFrame(() => {
    activateKitUgc(Math.round(kitUgcFeed.scrollTop / kitUgcFeed.clientHeight));
  });
  clearTimeout(kitUgcWrapTimer);
  kitUgcWrapTimer = setTimeout(wrapKitUgc, 120);
}, {passive:true});
kitUgcFeed.addEventListener('scrollend', wrapKitUgc);
kitUgcDialog.addEventListener('keydown', event => {
  const direction = ['ArrowDown', 'PageDown', ' '].includes(event.key) ? 1
    : ['ArrowUp', 'PageUp'].includes(event.key) ? -1 : 0;
  if (!direction) return;
  event.preventDefault();
  const index = Math.round(kitUgcFeed.scrollTop / kitUgcFeed.clientHeight);
  const next = Math.max(0, Math.min(kitUgcVideos.length - 1, index + direction));
  kitUgcFeed.scrollTo({top:next * kitUgcFeed.clientHeight,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
document.querySelector('#kit-ugc-close').addEventListener('click', () => kitUgcDialog.close());
kitUgcDialog.addEventListener('close', () => {
  cancelAnimationFrame(kitUgcScrollFrame);
  clearTimeout(kitUgcWrapTimer);
  kitUgcVideos.forEach(video => {
    video.pause();
    if (video.readyState) video.currentTime = 0;
  });
  kitUgcActive = -1;
  kitUgcResetting = false;
  document.body.classList.remove('kit-ugc-open');
  kitUgcOpen.focus();
});

const kitForm = document.querySelector('#kit-cart-form');
const kitTiers = [...document.querySelectorAll('.kit-tier-option')];
const kitColors = [...document.querySelectorAll('input[name="kit-color-choice"]')];
const kitFormulas = [...document.querySelectorAll('.kit-formula-option')];
const kitCounts = Object.fromEntries(kitFormulas.map(option => [option.dataset.formula, 0]));
const kitCartItems = document.querySelector('#kit-cart-items');
let kitConfigId = createKitConfigId();

function createKitConfigId() {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : 'basic-' + Date.now() + '-' + Math.random().toString(36).slice(2);
}

function kitPlural(count) {
  return count === 1 ? 'recharge' : 'recharges';
}

function kitMoney(amount) {
  return 'CHF ' + amount + '.–';
}

function kitSelection() {
  const color = kitColors.find(input => input.checked);
  const selected = kitFormulas.filter(option => kitCounts[option.dataset.formula] > 0);
  const total = selected.reduce((sum, option) => sum + kitCounts[option.dataset.formula], 0);
  const offer = total >= 5 ? 'applicator_free' : total >= 2 ? 'kit_30' : 'starter';
  const discount = total >= 5 ? 14 : total >= 2 ? 4 : 0;
  // Au-delà de sept recharges, une autre promotion Shopify peut interagir avec le kit.
  const price = total >= 1 && total <= 7 ? 14 + total * 10 - discount : null;
  const compareAt = price === null ? null : 14 + total * 10;
  const savings = compareAt === null ? 0 : compareAt - price;
  return {color, selected, total, offer, price, compareAt, savings};
}

function addKitInput(name, value) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = String(value);
  input.setAttribute('value', String(value));
  kitCartItems.append(input);
}

function renderKitCartItems(selection) {
  kitCartItems.replaceChildren();
  const common = {
    _basic_config_id: kitConfigId,
    _basic_source: 'kiima_configurator',
    _basic_color: selection.color.value,
    _basic_refill_quantity: selection.total,
    _basic_offer_tier: selection.offer
  };
  const lines = [
    {id: selection.color.dataset.id, quantity: 1, properties: {...common, _basic_item_role: 'applicator'}},
    ...selection.selected.map(option => ({
      id: option.dataset.id,
      quantity: kitCounts[option.dataset.formula],
      properties: {...common, _basic_item_role: 'refill', _basic_refill_variant: option.dataset.id}
    }))
  ];
  lines.forEach((line, index) => {
    addKitInput('items[' + index + '][id]', line.id);
    addKitInput('items[' + index + '][quantity]', line.quantity);
    Object.entries(line.properties).forEach(([key, value]) => {
      addKitInput('items[' + index + '][properties][' + key + ']', value);
    });
  });
}

function updateKitPhoto(selection) {
  const first = kitThumbs[0];
  first.dataset.src = selection.color.dataset.galleryHero;
  first.dataset.alt = kitGalleryCopy.heroAlt(selection.color.dataset.name);
  first.setAttribute('aria-label', kitGalleryCopy.heroLabel);
  (window.BasicProductImages ? window.BasicProductImages.setImage(first.querySelector('img'), first.dataset.src) : (first.querySelector('img').removeAttribute('srcset'), first.querySelector('img').src = first.dataset.src));
  if (kitPhotoIndex === 0) showKitPhoto(0, true);
}

function updateKitUI(changeImage = false) {
  const selection = kitSelection();
  kitTiers.forEach(tier => {
    const active = selection.total > 0 && tier.dataset.offer === selection.offer;
    tier.classList.toggle('is-selected', active);
    tier.setAttribute('aria-current', String(active));
  });
  kitColors.forEach(input => input.closest('.kit-color-option').classList.toggle('is-selected', input === selection.color));
  document.querySelector('#kit-selected-color').textContent = selection.color.dataset.name;
  document.querySelector('#kit-refill-count').textContent = selection.total + ' ' + kitPlural(selection.total) + ' ' + (selection.total === 1 ? 'choisie' : 'choisies');

  kitFormulas.forEach(option => {
    const quantity = kitCounts[option.dataset.formula];
    option.classList.toggle('is-selected', quantity > 0);
    option.querySelector('output').textContent = String(quantity);
    option.querySelector('.kit-step-minus').disabled = quantity === 0;
    option.querySelector('.kit-step-plus').disabled = false;
  });

  const complete = selection.total > 0;
  const help = document.querySelector('#kit-formula-help');
  help.textContent = selection.total === 0
    ? 'Ajoute au moins une recharge. Tu peux mélanger les formules ou choisir plusieurs fois la même.'
    : selection.total === 1
      ? 'Ton kit est prêt. Une deuxième recharge active CHF 4 de remise automatiquement.'
      : selection.total === 4
        ? 'Ajoute une cinquième recharge sans payer plus : ton kit reste à CHF 50.–'
        : selection.total > 7
          ? 'Ton kit est prêt. D’autres remises peuvent s’appliquer : le prix final apparaît dans le panier.'
          : selection.total >= 5
            ? 'Ton applicateur est offert. Tu peux encore ajouter des recharges.'
            : 'CHF 4 de remise sont appliqués. Continue à composer ton kit si tu le souhaites.';
  help.classList.toggle('is-complete', complete);
  help.classList.toggle('is-opportunity', selection.total === 4);

  document.querySelector('#kit-current-offer').textContent = selection.total === 0
    ? 'Ces paliers s’appliqueront au fur et à mesure de ta sélection.'
    : selection.total === 1
      ? 'Palier actuel : Pour essayer.'
      : selection.total < 5
        ? 'Palier actuel : CHF 4 de remise.'
        : selection.total <= 7
          ? 'Palier actuel : applicateur offert.'
          : 'Palier de 5 recharges atteint. Prix final calculé au panier.';

  const summary = selection.selected.map(option => {
    const name = option.dataset.name.replace('Le ', '');
    return name + ' × ' + kitCounts[option.dataset.formula];
  }).join(', ');
  document.querySelector('#kit-summary-contents').textContent = complete
    ? '1 applicateur + ' + selection.total + ' ' + kitPlural(selection.total) + ' · ' + summary
    : '1 applicateur + recharge à choisir';
  const comparison = document.querySelector('#kit-summary-compare');
  comparison.hidden = selection.savings === 0;
  comparison.textContent = selection.savings ? kitMoney(selection.compareAt) + ' séparément' : '';
  const savings = document.querySelector('#kit-savings');
  savings.hidden = selection.savings === 0;
  if (selection.savings) {
    const amount = document.createElement('strong');
    amount.textContent = kitMoney(selection.savings) + ' économisés';
    savings.replaceChildren(amount);
  } else {
    savings.replaceChildren();
  }
  const price = selection.total === 0 ? 'Dès CHF 24.–' : selection.price === null ? 'Prix au panier' : kitMoney(selection.price);
  document.querySelector('#kit-summary-price').textContent = price;
  document.querySelector('#kit-add-price').textContent = price;
  document.querySelector('#kit-sticky-price').textContent = price;
  document.querySelector('#kit-sticky-formula').textContent = selection.total + ' ' + kitPlural(selection.total);
  document.querySelector('#kit-add-label').textContent = complete
    ? selection.price === null ? 'Voir mon prix au panier' : 'Ajouter mon kit'
    : 'Ajoute une recharge';
  const checkoutNote = document.querySelector('#kit-checkout-note');
  checkoutNote.hidden = selection.total <= 7;
  checkoutNote.textContent = selection.total > 7
    ? 'Au-delà de 7 recharges, d’autres promotions peuvent interagir. Le total exact devra être confirmé lors de la commande.'
    : '';
  const addButton = document.querySelector('#kit-add-button');
  const stickyButton = document.querySelector('#kit-mobile-buy button');
  addButton.disabled = !complete;
  stickyButton.disabled = !complete;
  stickyButton.textContent = complete ? selection.price === null ? 'Voir au panier' : 'Ajouter mon kit' : 'Choisir une recharge';

  renderKitCartItems(selection);
  if (changeImage) updateKitPhoto(selection);
}

kitColors.forEach(input => input.addEventListener('change', () => {
  updateKitUI(true);
  if (kitPhotoIndex !== 0) showKitPhoto(0);
}));
kitFormulas.forEach(option => {
  const key = option.dataset.formula;
  option.querySelector('.kit-step-minus').addEventListener('click', () => {
    if (kitCounts[key] === 0) return;
    kitCounts[key]--;
    updateKitUI(true);
  });
  option.querySelector('.kit-step-plus').addEventListener('click', () => {
    kitCounts[key]++;
    updateKitUI(true);
  });
});

kitForm.addEventListener('submit', event => {
  const selection = kitSelection();
  if (selection.total < 1) {
    event.preventDefault();
    document.querySelector('.kit-formulas').scrollIntoView({behavior:'smooth', block:'center'});
    return;
  }
  kitConfigId = createKitConfigId();
  renderKitCartItems(selection);
});

updateKitUI();

const kitSticky = document.querySelector('#kit-mobile-buy');
const kitClosing = document.querySelector('.kit-closing');
function updateKitSticky() {
  const buyBox = kitForm.getBoundingClientRect();
  const passedBuyBox = buyBox.bottom < 82;
  const nearEnd = kitClosing.getBoundingClientRect().top < window.innerHeight * .82;
  const visible = window.innerWidth <= 700 && passedBuyBox && !nearEnd && !document.body.classList.contains('menu-locked') && !document.body.classList.contains('kit-ugc-open');
  kitSticky.classList.toggle('is-visible', visible);
  kitSticky.setAttribute('aria-hidden', String(!visible));
  kitSticky.inert = !visible;
}
window.addEventListener('scroll', updateKitSticky, {passive:true});
window.addEventListener('resize', updateKitSticky);
new MutationObserver(updateKitSticky).observe(document.body, {attributes:true,attributeFilter:['class']});
updateKitSticky();
